import { Alert, List, ListItem, Stack, Typography } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { AcceptedImportColumn, ImportedPriceSuggestionPrice } from '@retail/price-suggestion/types';
import { getColumnName } from '@retail/price-suggestion/utils';

interface Props {
  validRows?: ImportedPriceSuggestionPrice[];
  invalidRows?: number;
  totalRows?: number;
  missingColumns?: AcceptedImportColumn[];
}

export function LocalPriceSuggestionPricesUploadValidation({
  validRows,
  invalidRows,
  totalRows,
  missingColumns,
}: Props) {
  const t = useAppTFunction();
  return (
    <Stack gap={1}>
      {!!validRows && validRows.length > 0 && (
        <Alert severity="success" sx={{ display: 'flex', alignItems: 'center' }}>
          {t('products.uploadItems.nrItemsRead', {
            count: validRows.length,
            totalCount: totalRows,
          })}
        </Alert>
      )}

      {!!invalidRows && invalidRows > 0 && (
        <Alert severity="error" sx={{ display: 'flex', alignItems: 'center' }}>
          {t('products.uploadItems.invalidRows', {
            count: invalidRows,
            totalCount: totalRows,
          })}
        </Alert>
      )}

      {!!missingColumns && missingColumns.length > 0 && (
        <Alert severity="error" sx={{ display: 'flex', alignItems: 'center' }}>
          <Stack flexDirection="column">
            <Typography variant="subtitle2">{t('calculus.error.columnsMissing')}:</Typography>
            <List disablePadding sx={{ listStyleType: 'disc', pl: 2 }}>
              {missingColumns.map((column) => (
                <ListItem key={column} sx={{ display: 'list-item', pl: 1 }} dense>
                  {getColumnName({ t, columnName: column })}
                </ListItem>
              ))}
            </List>
          </Stack>
        </Alert>
      )}
    </Stack>
  );
}
